export default "__VITE_ASSET__Beh1mMLW__"